import { Routes } from '@angular/router';

export const cellularRoutes: Routes = [
  {
    path: 'simcards',
    loadComponent: () =>
      import('./simcard/components/dt-simcard/dt-simcard.component').then(
        (m) => m.DtSimcardComponent,
      ),
  },
  {
    path: 'mobile-operators',
    loadComponent: () =>
      import(
        './mobile-operator/components/dt-mobile-operator/dt-mobile-operator.component'
      ).then((m) => m.DtMobileOperatorComponent),
  },
];
